// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"1f4eabbf","513":"0de41b95","703":"7feade76"}[chunkId] + ".chunk.js";
};